import { PAYMENT_TYPES } from '@vend/business-components'
import { useAppSelector } from '../../../../state/hooks'
import { selectHasPaymentOfType } from '../../../../state/slices/currentSale/currentSaleSlice'

/**
 * Returns true when the current sale has at least one On Account payment entry,
 * regardless of net amount.
 *
 * Presence-based: On Account refunds are valid negative payments (see
 * functions/payment-types/onaccount.ts), so a sale with a positive payment and
 * a refund that net to zero or less must still be treated as having had an On
 * Account payment.
 *
 * This is deliberately stricter than useHasOnAccountPayment (tax-breakdown),
 * which is net-total based and correctly allows tax editing again once an On
 * Account charge is fully refunded. Layaway eligibility must not reappear
 * just because a refund offset the charge — once On Account has been used for
 * this sale, Layaway should remain permanently blocked.
 */
export const useHasOnAccountPaymentEntry = (): boolean =>
  // includeRetrievedPayments: true — when a parked/on-account sale is continued, its
  // existing payments are loaded from the API and flagged retrieved: true to distinguish
  // them from new payments added in the current session. The selector excludes retrieved
  // payments by default, so we must opt in to catch these API-hydrated payments.
  useAppSelector(selectHasPaymentOfType(PAYMENT_TYPES.ON_ACCOUNT, true))
